
const config = {
  API_URL: process.env.REACT_APP_API_URL,
  USER_MANAGER: 'admin',
  USER_WAITER: 'user',
  USER_SUPERADMIN: 'superadmin',
};

export default config;
